import axios from 'axios'

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status

    if (status === 401) {
      return 'Your session has expired. Please log in again and retry.'
    }

    if (status === 403) {
      return 'You do not have permission to access this data.'
    }

    if (error.code === 'ECONNABORTED') {
      return 'Request timed out. Please try again.'
    }

    if (!error.response) {
      return 'Unable to reach the server. Verify the API is running, then retry.'
    }

    const message = error.response?.data?.message
    if (typeof message === 'string' && message.trim()) {
      return message
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message
  }

  return fallback
}
